import CityPageTemplate from "../city-template/CityPageTemplate";
import { laredoConfig } from "./data";

export default function LaredoPage() {
  return <CityPageTemplate config={laredoConfig} />;
}